import { lazy, Suspense, useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";

import RequirePermission from "../guards/RequirePermission";
import { ROUTE_PERMISSIONS } from "../config/permissions";
import AppLayout from "../components/layout/AppLayout";

// Pages chargées à la demande (un fichier par page) : premier affichage plus rapide.
const AgencyCollaborations = lazy(() => import("../compnent/collaborations/Collaborations"));
const AgencyCollaborationDetails = lazy(() => import("../compnent/collaborations/CollaborationDetails"));
const AgencyCommissions = lazy(() => import("../compnent/commissions/AgencyCommissions"));
const Dashboard = lazy(() => import("../compnent/dashboard/Dashboard"));
const AgencyInvoices = lazy(() => import("../compnent/invoices/AgencyInvoices"));
const MessagingCenter = lazy(() => import("../compnent/messaging/MessagingCenter"));
const MyWallet = lazy(() => import("../compnent/wallet/MyWallet"));
const AgencyDispatchPage = lazy(() => import("./AgencyDispatchPage"));
const OrdersPage = lazy(() => import("./OrdersPage"));
const ProfilePage = lazy(() => import("./ProfilePage"));
const SettingsPage = lazy(() => import("./SettingsPage"));
const TeamUsersPage = lazy(() => import("./TeamUsersPage"));
const TrackingPage = lazy(() => import("./TrackingPage"));

const AppConfirmation = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [isTablet, setIsTablet] = useState(window.innerWidth >= 768 && window.innerWidth < 1024);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      const tablet = window.innerWidth >= 768 && window.innerWidth < 1024;
      setIsMobile(mobile);
      setIsTablet(tablet);

      if (mobile || tablet) {
        setSidebarOpen(false);
      } else {
        const savedState = localStorage.getItem("sidebarOpen");
        setSidebarOpen(savedState !== null ? JSON.parse(savedState) : true);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (!isMobile && !isTablet) {
      localStorage.setItem("sidebarOpen", JSON.stringify(sidebarOpen));
    }
  }, [sidebarOpen, isMobile, isTablet]);

  return (
    <AppLayout
      sidebarOpen={sidebarOpen}
      isMobile={isMobile}
      isTablet={isTablet}
      onCloseSidebar={() => setSidebarOpen(false)}
      onToggleSidebar={() => setSidebarOpen((previous) => !previous)}
    >
      <Suspense fallback={<p className="p-10 text-center text-sm text-app-muted" role="status">Loading…</p>}>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/orders" element={<Protected anyOf={ROUTE_PERMISSIONS.orders}><OrdersPage /></Protected>} />
        <Route path="/tracking" element={<Protected anyOf={ROUTE_PERMISSIONS.orders}><TrackingPage /></Protected>} />
        <Route path="/dispatch" element={<Protected anyOf={ROUTE_PERMISSIONS.dispatch}><AgencyDispatchPage /></Protected>} />
        <Route path="/collaborations" element={<Protected anyOf={ROUTE_PERMISSIONS.collaborations}><AgencyCollaborations /></Protected>} />
        <Route path="/collaboration/:id" element={<Protected anyOf={ROUTE_PERMISSIONS.collaborations}><AgencyCollaborationDetails /></Protected>} />
        <Route path="/wallet" element={<Protected anyOf={ROUTE_PERMISSIONS.wallet}><MyWallet /></Protected>} />
        <Route path="/commissions" element={<Protected anyOf={ROUTE_PERMISSIONS.commissions}><AgencyCommissions /></Protected>} />
        <Route path="/invoices" element={<Protected anyOf={ROUTE_PERMISSIONS.invoices}><AgencyInvoices /></Protected>} />
        <Route path="/messages" element={<Protected anyOf={ROUTE_PERMISSIONS.messages}><MessagingCenter /></Protected>} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/team" element={<Protected anyOf={ROUTE_PERMISSIONS.team}><TeamUsersPage /></Protected>} />
      </Routes>
      </Suspense>
    </AppLayout>
  );
};

const Protected = ({ anyOf, children }) => (
  <RequirePermission anyOf={anyOf}>{children}</RequirePermission>
);

export default AppConfirmation;
